import theme from "../../../../styles/theme";
import styled from "styled-components/macro";
import { FormControlLabel as MuiFormControlLabel } from "@material-ui/core";

export const FormControlLabel = styled(MuiFormControlLabel)`
  font-size: ${theme.typography.body2.fontSize};
`;
